import React, { FC } from 'react';
import { IEnrichedProduct } from '$models';
import { NonBookVariant } from './non-book-variant';
import { BookVariant } from './book-variant';

type Props = {
    selectedVariant: IEnrichedProduct;
    variants: IEnrichedProduct[];
    formatInformation?: string;
};

export const ProductVariantSelector: FC<Props> = ({
    selectedVariant,
    variants,
    formatInformation,
}: Props): JSX.Element => {
    const { product } = selectedVariant;

    return (
        <>
            {!product?.isBook && <NonBookVariant selectedVariant={selectedVariant} variants={variants} />}
            {product?.isBook && (
                <BookVariant
                    selectedVariant={selectedVariant}
                    variants={variants}
                    formatInformation={formatInformation}
                />
            )}
        </>
    );
};
